"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dateFns = require("date-fns");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

require("moment/locale/ca");

var _rcSlider = require("rc-slider");

var _rcSlider2 = _interopRequireDefault(_rcSlider);

var _share = require("../../utils/share");

var _share2 = _interopRequireDefault(_share);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _PanelTractarDades = require("./PanelTractarDades.css");

var _PanelTractarDades2 = _interopRequireDefault(_PanelTractarDades);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//     

var newOptions = {
	rang: {
		max: -20,
		min: 40
	}
};
var updatedList = [];
var fieldValuesLabel = {
	rang: {
		max: 0,
		min: 0
	}
};

var PanelTractarDades = function (_React$Component) {
	_inherits(PanelTractarDades, _React$Component);

	function PanelTractarDades(props) {
		_classCallCheck(this, PanelTractarDades);

		var _this = _possibleConstructorReturn(this, (PanelTractarDades.__proto__ || Object.getPrototypeOf(PanelTractarDades)).call(this, props));

		_this.handleChangeDbExtra = function (event, data) {

			_this.updateOptions(_extends({}, _this.props.calcdatafieldsOptions, {
				dbextra: data.value
			}));
		};

		_this.handleChangeField = function (event, data) {

			var newList = _this.state.fields;

			if (data.checked) {
				newList.add(data.label);
			} else {
				newList.delete(data.label);
			}
			var array = Array.from(newList);
			updatedList = array;
			// console.log('updat', updatedList)
			_this.resetFieldsAndCalculs(newList);
		};

		_this.isToday = function () {
			return _this.props.timerange.tipus === CONSTANTS.TODAY;
		};

		var selectedField = _this.props.calcdatafields.length > 0 ? _this.props.calcdatafields[0] : "default_field";
		// console.log('selected', selectedField)
		var selectedFieldValues = _share2.default.getObtionsByActiveField(selectedField);
		// console.log('selectedFieldValues', selectedFieldValues)
		_this.state = {

			fields: new Set(props.calcdatafields),
			selectedFields: new Set(props.selectedfields),
			missingSelectedFields: false,
			missingCalculs: false,
			selectedFieldValues: selectedFieldValues
		};

		_this.isUltimValor = _this.props.timerange.tipus === CONSTANTS.LATEST;
		_this.handleChangeField = _this.handleChangeField.bind(_this);
		_this.handleChangeSync = _this.handleChangeSync.bind(_this);
		_this.handleChangeDbExtra = _this.handleChangeDbExtra.bind(_this);

		var createSliderWithTooltip = _rcSlider2.default.createSliderWithTooltip;
		_this.Range = createSliderWithTooltip(_rcSlider2.default.Range);

		return _this;
	}

	_createClass(PanelTractarDades, [{
		key: "componentDidMount",
		value: function componentDidMount() {

			if (!this.props.iscat && this.props.calcdatafieldsOptions.hora === "25") {
				this.updateOptions(_extends({}, this.props.calcdatafieldsOptions, { hora: "23" }));
			}
		}
	}, {
		key: "handleChangeSync",
		value: function handleChangeSync() {

			this.updateOptions(_extends({}, this.props.calcdatafieldsOptions, {
				sincronitzacio: !this.props.calcdatafieldsOptions.sincronitzacio
			}));
		}
	}, {
		key: "handleToggleDbExtra",
		value: function handleToggleDbExtra() {
			this.updateOptions(_extends({}, this.props.calcdatafieldsOptions, {
				dbextraprimaria: !this.props.calcdatafieldsOptions.dbextraprimaria
			}));
		}
	}, {
		key: "updateOptions",
		value: function updateOptions(newOptionss) {

			//ccada cop que mous el slider es recarrega el rang min max
			fieldValuesLabel.rang.max = newOptionss.rang.max;
			fieldValuesLabel.rang.min = newOptionss.rang.min;
			this.setState({ options: newOptionss });
			this.props.updateJsonConfig("calcdatafieldsOptions", newOptionss);
		}
	}, {
		key: "renderSelectOrdre",
		value: function renderSelectOrdre() {
			var _this2 = this;

			if (this.props.calcdatafieldsOptions.dbextra === "") return;

			var labelExtra = this.props.calcdatafieldsOptions.dbextra.toUpperCase() + " valors";
			var labelCSV = "CSV valors";

			if (this.props.calcdatafieldsOptions.dbextraprimaria) {
				return _react2.default.createElement(
					_semanticUiReact.Item,
					null,
					_react2.default.createElement(
						"p",
						null,
						"Ordre de les operacions:"
					),
					_react2.default.createElement(
						_semanticUiReact.Label,
						null,
						labelExtra
					),
					" - ",
					_react2.default.createElement(
						_semanticUiReact.Label,
						null,
						labelCSV
					),
					_react2.default.createElement(_semanticUiReact.Button, { onClick: function onClick(e) {
							return _this2.handleToggleDbExtra();
						}, circular: true, icon: "refresh" })
				);
			} else {
				return _react2.default.createElement(
					_semanticUiReact.Item,
					null,
					_react2.default.createElement(
						"p",
						null,
						"Ordre de les operacions:"
					),
					_react2.default.createElement(
						_semanticUiReact.Label,
						null,
						labelCSV
					),
					" - ",
					_react2.default.createElement(
						_semanticUiReact.Label,
						null,
						labelExtra
					),
					_react2.default.createElement(_semanticUiReact.Button, { onClick: function onClick(e) {
							return _this2.handleToggleDbExtra();
						}, circular: true, icon: "refresh" })
				);
			}
		}
	}, {
		key: "renderCSVOptions",
		value: function renderCSVOptions() {

			if (!this.props.isCSVFile) return;

			return _react2.default.createElement(
				_semanticUiReact.Segment,
				null,
				_react2.default.createElement(
					"h4",
					null,
					"Opcions CSV:"
				),
				_react2.default.createElement(
					_semanticUiReact.Item.Group,
					null,
					_react2.default.createElement(
						_semanticUiReact.Item,
						null,
						_react2.default.createElement(_semanticUiReact.Checkbox, { toggle: true, checked: this.props.calcdatafieldsOptions.sincronitzacio, onChange: this.handleChangeSync, label: "Sincronitzaci\xF3 permanent de les dades" })
					),
					_react2.default.createElement(
						"h4",
						null,
						"Sobre quina base de dades addicional vols operar?"
					),
					_react2.default.createElement(
						_semanticUiReact.Item,
						null,
						_react2.default.createElement(_semanticUiReact.Checkbox, {
							radio: true,
							label: "Cap (nom\xE9s el CSV afegit)",
							name: "dbExtraRadioGroup",
							value: "",
							checked: this.props.calcdatafieldsOptions.dbextra === "",
							onChange: this.handleChangeDbExtra
						})
					),
					_react2.default.createElement(
						_semanticUiReact.Item,
						null,
						_react2.default.createElement(_semanticUiReact.Checkbox, {
							radio: true,
							label: CONSTANTS.DB_TEMPS_ACTUAL,
							name: "dbExtraRadioGroup",
							value: CONSTANTS.DB_TEMPS_ACTUAL,
							checked: this.props.calcdatafieldsOptions.dbextra === CONSTANTS.DB_TEMPS_ACTUAL,
							onChange: this.handleChangeDbExtra
						})
					),
					_react2.default.createElement(
						_semanticUiReact.Item,
						null,
						_react2.default.createElement(_semanticUiReact.Checkbox, {
							radio: true,
							label: CONSTANTS.DB_METEODADES,
							name: "dbExtraRadioGroup",
							value: CONSTANTS.DB_METEODADES,
							checked: this.props.calcdatafieldsOptions.dbextra === CONSTANTS.DB_METEODADES,
							onChange: this.handleChangeDbExtra
						})
					),
					this.renderSelectOrdre()
				)
			);
		}
	}, {
		key: "renderSelectGranularitatHores",
		value: function renderSelectGranularitatHores(granularitat) {
			var _this3 = this;

			if (granularitat === CONSTANTS.GRANULARITAT_DIES) {
				var iscat = this.props.iscat;


				return _react2.default.createElement(_semanticUiReact.Select, {
					button: true,
					className: "icon",
					icon: "clock",
					labeled: true, search: true,
					placeholder: "Selecciona hora",
					options: iscat ? [].concat(_toConsumableArray(CONSTANTS.SELECT_GRANULARITAT_HORES), [CONSTANTS.SELECT_HORA25]) : CONSTANTS.SELECT_GRANULARITAT_HORES,
					onChange: function onChange(e, data) {
						return _this3.updateOptions(_extends({}, _this3.props.calcdatafieldsOptions, { hora: data.value }));
					},
					value: this.props.calcdatafieldsOptions.hora
				});
			}
		}
	}, {
		key: "renderSelectGranularitat",
		value: function renderSelectGranularitat() {
			var _this4 = this;

			var granularitat = this.props.calcdatafieldsOptions.granularitat;
			var timerange = this.props.timerange;


			var numberOfWeeks = (0, _dateFns.differenceInWeeks)(new Date(timerange.timemax), new Date(timerange.timemin));

			return _react2.default.createElement(
				_semanticUiReact.Segment,
				null,
				_react2.default.createElement(
					"h4",
					null,
					"Selecciona la granularitat de les dades:"
				),
				_react2.default.createElement(
					"div",
					{ className: _PanelTractarDades2.default.containerSelectGranu },
					_react2.default.createElement(_semanticUiReact.Select, {
						disabled: numberOfWeeks > 2,
						options: CONSTANTS.SELECT_GRANULARITAT_OPTIONS,
						onChange: function onChange(e, data) {
							return _this4.updateOptions(_extends({}, _this4.props.calcdatafieldsOptions, { granularitat: data.value }));
						},
						defaultValue: granularitat
					}),
					this.renderSelectGranularitatHores(granularitat)
				),
				numberOfWeeks > 2 && _react2.default.createElement(
					_semanticUiReact.Message,
					{ warning: true, compact: true, size: "tiny" },
					_react2.default.createElement(_semanticUiReact.Icon, { name: "warning" }),
					"Per rangs temporals superiors a 2 setmanes, la granularitat de les dades nom\xE9s pot ser 'Dies'"
				)
			);
		}
	}, {
		key: "resetFieldsAndCalculs",
		value: function resetFieldsAndCalculs(newList) {

			var props = ["calcdatafields", "vieweroptions"];
			var data = [Array.from(newList), CONSTANTS.defaultJsonConfig.vieweroptions];

			var calcSumatori = newList.has("pluja") && this.props.calcdatafieldsCalculs._sum;
			var calcValue = this.props.calcdatafieldsCalculs._calcvalue;

			var listArray = Array.from(newList);
			//per generar rangs al tractament inicial
			if (newList.size === 1 || newList.size === 2 && newList.has('alt')) {
				var optionsField = void 0;
				if (newList.size === 2 && newList.has('alt') && listArray[0] === 'alt') {

					optionsField = _share2.default.getObtionsByActiveField(Array.from(newList)[1]);
				} else {
					optionsField = _share2.default.getObtionsByActiveField(Array.from(newList)[0]);
				}

				this.setState({ selectedFieldValues: optionsField, fields: newList });
				props.push("calcdatafieldsOptions");
				data.push(_extends({}, this.props.calcdatafieldsOptions, { rang: { "min": optionsField.min, "max": optionsField.max } }));
				fieldValuesLabel.rang.max = optionsField.max;
				fieldValuesLabel.rang.min = optionsField.min;
			} else {

				calcValue = false;
				this.setState({ fields: newList });
			}

			props.push("calcdatafieldsCalculs");
			data.push(_extends({}, this.props.calcdatafieldsCalculs, { _calcvalue: calcValue, _sum: calcSumatori }));

			this.props.updateJsonConfig(props, data);
		}
	}, {
		key: "fillHoursDiaDynamic",
		value: function fillHoursDiaDynamic(addUltimaHora) {

			var options = [];
			if ((0, _dateFns.getHours)(new Date()) >= 3) {

				var hours = (0, _dateFns.getHours)((0, _dateFns.subHours)(new Date(), 2));
				for (var i = 1; i <= hours; i++) {
					options.push({ key: i, value: "" + i, text: i + ":00h" });
				}
			} else {
				// no hi haura dades

				options.push({ key: 1, value: "1", text: "01:00h" }, { key: 2, value: "2", text: "02:00h" });
			}

			if (addUltimaHora) options.push(CONSTANTS.OPT_ULTIMAHORA);

			return options;
		}
	}, {
		key: "renderCalculComparativesSelectHora",
		value: function renderCalculComparativesSelectHora() {
			var _this5 = this;

			var label = "Hores a comparar:";
			var labelDia = "Dia";

			var myOptionsDia1 = [].concat(_toConsumableArray(CONSTANTS.OPT_HORES));
			var myOptionsDia2 = [].concat(_toConsumableArray(CONSTANTS.OPT_HORES));

			if (this.isToday()) {

				label = "Hores a comparar del 'Dia Actual':";
				labelDia = "Hora";
				//this.updateOptions({...this.props.calcdatafieldsOptions, horafiltremin: CONSTANTS.OPT_ULTIMAHORA.value});

				myOptionsDia1 = this.fillHoursDiaDynamic(false);
				myOptionsDia2 = [CONSTANTS.OPT_ULTIMAHORA];
			} else if (this.props.timerange.dynamic) {

				myOptionsDia2 = this.fillHoursDiaDynamic(true);
			}

			/* const myOptionsDia2 = (this.props.timerange.dynamic ? this.fillHoursDiaDynamic(true) : [...CONSTANTS.OPT_HORES]); */
			/* const isUltimaHoraDia2 = (this.props.calcdatafieldsOptions.horafiltremax === -1); */

			return _react2.default.createElement(
				_semanticUiReact.Grid,
				{ className: _PanelTractarDades2.default.gridComparativa, stackable: true, padded: true },
				_react2.default.createElement(
					_semanticUiReact.Grid.Row,
					{ className: _PanelTractarDades2.default.boldPrimaryColor },
					label
				),
				_react2.default.createElement(
					_semanticUiReact.Grid.Row,
					{ columns: 2 },
					_react2.default.createElement(
						_semanticUiReact.Grid.Column,
						null,
						_react2.default.createElement(
							_semanticUiReact.Item,
							null,
							_react2.default.createElement(
								_semanticUiReact.Item.Content,
								null,
								_react2.default.createElement(
									_semanticUiReact.Item.Meta,
									null,
									_react2.default.createElement(
										_semanticUiReact.Label,
										{ color: "teal" },
										labelDia,
										" 1"
									),
									" ",
									(0, _moment2.default)(this.props.timerange.timemin).format("DD/MM/YYYY")
								),
								_react2.default.createElement(
									_semanticUiReact.Item.Description,
									null,
									_react2.default.createElement(_semanticUiReact.Select, {
										scrolling: true,
										onChange: function onChange(e, data) {
											return _this5.updateOptions(_extends({}, _this5.props.calcdatafieldsOptions, { horafiltremin: data.value }));
										},
										value: this.props.calcdatafieldsOptions.horafiltremin,
										size: "mini",
										options: myOptionsDia1,
										className: _PanelTractarDades2.default.mySelect
									})
								)
							)
						)
					),
					_react2.default.createElement(
						_semanticUiReact.Grid.Column,
						null,
						_react2.default.createElement(
							_semanticUiReact.Item,
							null,
							_react2.default.createElement(
								_semanticUiReact.Item.Content,
								null,
								_react2.default.createElement(
									_semanticUiReact.Item.Meta,
									null,
									_react2.default.createElement(
										_semanticUiReact.Label,
										{ color: "teal" },
										labelDia,
										" 2"
									),
									" ",
									(0, _moment2.default)(this.props.timerange.timemax).format("DD/MM/YYYY")
								),
								_react2.default.createElement(
									_semanticUiReact.Item.Description,
									null,
									_react2.default.createElement(_semanticUiReact.Select, {
										onChange: function onChange(e, data) {
											return _this5.updateOptions(_extends({}, _this5.props.calcdatafieldsOptions, { horafiltremax: data.value }));
										},
										value: this.props.calcdatafieldsOptions.horafiltremax,
										size: "mini",
										options: myOptionsDia2,
										className: _PanelTractarDades2.default.mySelect
									}),
									this.props.calcdatafieldsOptions.horafiltremax === CONSTANTS.OPT_ULTIMAHORA.value && _react2.default.createElement(
										_semanticUiReact.Message,
										{ info: true, size: "small" },
										_react2.default.createElement(_semanticUiReact.Icon, { name: "info circle" }),
										"La comparativa es far\xE0 sempre amb la ",
										_react2.default.createElement(
											"b",
											null,
											"\xFAltima hora"
										),
										" disponible."
									)
								)
							)
						)
					)
				)
			);
		}
	}, {
		key: "renderCalculComparatives",
		value: function renderCalculComparatives() {
			var _this6 = this;

			var isDisabled = !this.props.timerange.singledays && !this.isToday() || !(this.state.fields.size === 1);

			return _react2.default.createElement(
				_semanticUiReact.Item.Group,
				null,
				_react2.default.createElement(
					_semanticUiReact.Item,
					null,
					_react2.default.createElement(_semanticUiReact.Checkbox, {
						toggle: true,
						disabled: isDisabled,
						checked: this.props.calcdatafieldsCalculs._calcvalue,
						onChange: function onChange(e, data) {
							return _this6.props.updateJsonConfig(["calcdatafieldsCalculs", "calcdatafieldsOptions"], [_extends({}, _this6.props.calcdatafieldsCalculs, { _calcvalue: data.checked }), _extends({}, _this6.props.calcdatafieldsOptions, { horafiltremax: _this6.isToday() ? CONSTANTS.OPT_ULTIMAHORA.value : "1" })]);
						},
						label: "Difer\xE8ncia de valors / Comparativa"
					}),
					_react2.default.createElement(_semanticUiReact.Popup, {
						size: "small",
						className: _PanelTractarDades2.default.myPopUp,
						position: "right center",
						trigger: _react2.default.createElement(_semanticUiReact.Icon, { className: _PanelTractarDades2.default.iconPopup, size: "small", fitted: true, circular: true, color: "teal", name: "question" }),
						content: "Disponible nom\xE9s quan el rang temporal \xE9s de 2 dies concrets o el dia actual (PAS 2)" })
				),
				this.props.calcdatafieldsCalculs._calcvalue && this.renderCalculComparativesSelectHora()
			);
		}
	}, {
		key: "renderFormCalculs",
		value: function renderFormCalculs() {
			var _this7 = this;

			var itemsList = [];

			CONSTANTS.OPT_CALCULS.forEach(function (item, index) {

				if (item.value !== CONSTANTS.OPT_CALCULS_CALCVALUE) {
					itemsList.push(_react2.default.createElement(
						_semanticUiReact.Item,
						{ key: index, className: _PanelTractarDades2.default.itemCalcul },
						_react2.default.createElement(_semanticUiReact.Checkbox, {
							className: _PanelTractarDades2.default.itemCalculCheckbox,
							key: item.key,
							toggle: true,
							value: item.value,
							disabled: _this7.isUltimValor || item.value === CONSTANTS.OPT_CALCULS_SUM && !_this7.state.fields.has("pluja"),
							checked: _this7.props.calcdatafieldsCalculs[item.value],
							onChange: function onChange(e, data) {
								return _this7.props.updateJsonConfig("calcdatafieldsCalculs", _extends({}, _this7.props.calcdatafieldsCalculs, _defineProperty({}, item.value, data.checked)));
							},
							label: item.text
						}),
						item.value === CONSTANTS.OPT_CALCULS_SUM && _react2.default.createElement(_semanticUiReact.Popup, {
							size: "small",
							className: _PanelTractarDades2.default.myPopUp,
							position: "right center",
							trigger: _react2.default.createElement(_semanticUiReact.Icon, { className: _PanelTractarDades2.default.iconPopup, size: "small", fitted: true, circular: true, color: "teal", name: "question" }),
							content: "Nom\xE9s disponible amb el camp pluja seleccionat" })
					));
				}
			});

			return itemsList;
		}
	}, {
		key: "renderFieldsItems",
		value: function renderFieldsItems() {
			var _this8 = this;

			var list = [];
			// console.log('kk',this.state.selectedFields)
			CONSTANTS.DEFAULT_NUMERIC_FIELDS.map(function (item, i) {
				return list.push(_this8.state.selectedFields.has(item) && _react2.default.createElement(
					_semanticUiReact.List.Item,
					{ className: _PanelTractarDades2.default.checkboxItem, key: i },
					_react2.default.createElement(_semanticUiReact.Checkbox, {
						className: _this8.state.fields.has(item) ? _PanelTractarDades2.default.selectedLabel : "",
						checked: _this8.state.fields.has(item),

						onChange: _this8.handleChangeField,
						label: item
					})
				));
			});

			return list;
		}
	}, {
		key: "renderRangValors",
		value: function renderRangValors() {
			var _this9 = this;

			if (this.props.calcdatafields.length === 1 && !this.props.calcdatafields.includes('alt') || this.props.calcdatafields.length === 2 && this.props.calcdatafields.includes('alt')) {
				if (this.props.calcdatafields.length === 2) {
					if (this.props.calcdatafields[0] === 'alt') {
						this.props.calcdatafields[0] = this.props.calcdatafields[1];
						this.props.calcdatafields[1] = 'alt';
					}
				}

				var fieldValues = this.state.selectedFieldValues;

				return _react2.default.createElement(
					_semanticUiReact.Item,
					{ className: _PanelTractarDades2.default.itemRangs },
					_react2.default.createElement(
						_semanticUiReact.Item.Content,
						null,
						_react2.default.createElement(
							_semanticUiReact.Item.Meta,
							null,
							_react2.default.createElement(
								"b",
								null,
								"Rang de valors del camp seleccionat:"
							),
							"\xA0\xA0",
							_react2.default.createElement(
								"span",
								{ className: _PanelTractarDades2.default.rangItemLabel },
								this.props.calcdatafields[0]
							),
							_react2.default.createElement(_semanticUiReact.Popup, {
								size: "small",
								className: _PanelTractarDades2.default.myPopUp,
								position: "right center",
								trigger: _react2.default.createElement(_semanticUiReact.Icon, { className: _PanelTractarDades2.default.iconPopup, size: "small", fitted: true, circular: true, color: "teal", name: "question" }),
								content: "El filtre s'efectuar\xE0 sobre tots els c\xE0lculs seleccionats" })
						),
						_react2.default.createElement(
							_semanticUiReact.Item.Description,
							null,
							_react2.default.createElement(
								"div",
								{ className: _PanelTractarDades2.default.flexRow },
								_react2.default.createElement(
									_semanticUiReact.Label,
									{ color: "teal", className: _PanelTractarDades2.default.labelRange },
									fieldValuesLabel.rang.min
								),
								_react2.default.createElement(
									"div",
									{ className: _PanelTractarDades2.default.mySlider },
									_react2.default.createElement(this.Range, {
										max: fieldValues.max,
										min: fieldValues.min,
										allowCross: false,
										value: [this.props.calcdatafieldsOptions.rang.min, this.props.calcdatafieldsOptions.rang.max],
										onChange: function onChange(value) {
											return _this9.updateOptions(_extends({}, _this9.props.calcdatafieldsOptions, { rang: { min: value[0], max: value[1] } }));
										}
									})
								),
								_react2.default.createElement(
									_semanticUiReact.Label,
									{ color: "teal", className: _PanelTractarDades2.default.labelRange },
									fieldValuesLabel.rang.max
								)
							)
						)
					)
				);
			}

			return _react2.default.createElement(
				_semanticUiReact.Item,
				{ className: _PanelTractarDades2.default.itemRangsDisabled },
				_react2.default.createElement(
					_semanticUiReact.Item.Content,
					null,
					_react2.default.createElement(
						_semanticUiReact.Item.Meta,
						null,
						"Rang de valors del camp seleccionat: - "
					),
					_react2.default.createElement(
						_semanticUiReact.Item.Description,
						null,
						_react2.default.createElement(
							"div",
							{ className: _PanelTractarDades2.default.mySliderDisabled },
							_react2.default.createElement(this.Range, {
								disabled: true,
								max: 100,
								min: 0,
								allowCross: false,
								value: [0, 100]
							})
						)
					)
				)
			);
		}
	}, {
		key: "renderFields",
		value: function renderFields() {

			return _react2.default.createElement(
				_semanticUiReact.Segment,
				null,
				_react2.default.createElement(
					"h4",
					null,
					"Selecciona els camps que es tractaran:"
				),
				_react2.default.createElement(_semanticUiReact.Message, {
					icon: "info circle",
					list: this.isUltimValor ? CONSTANTS.PAS5_INFO_LIST_ULTIMVALUE : CONSTANTS.PAS5_INFO_LIST,
					compact: true,
					info: true
				}),
				_react2.default.createElement(
					"div",
					{ className: _PanelTractarDades2.default.containerFields },
					this.renderFieldsItems()
				),
				_react2.default.createElement(_semanticUiReact.Divider, null),
				this.renderRangValors()
			);
		}
	}, {
		key: "id",
		value: function id() {
			if (this.props.calcdatafields.length === 0) {
				return _react2.default.createElement(
					_semanticUiReact.Segment,
					null,
					_react2.default.createElement(
						"h5",
						{ className: _PanelTractarDades2.default.selecciona },
						"Selecciona un camp per veure els c\xE0lculs disponibles."
					)
				);
			}

			if (this.props.calcdatafields.length === 1 && this.props.calcdatafields.includes('alt')) {
				return _react2.default.createElement(
					_semanticUiReact.Segment,
					null,
					_react2.default.createElement(
						"h5",
						{ className: _PanelTractarDades2.default.selecciona },
						"Selecciona un camp addicional per veure els seus c\xE0lculs disponibles."
					)
				);
			} else {
				return _react2.default.createElement(
					_semanticUiReact.Segment,
					null,
					_react2.default.createElement(
						"h5",
						null,
						"Selecci\xF3  de c\xE0lculs:"
					),
					_react2.default.createElement(_semanticUiReact.Divider, null),
					_react2.default.createElement(
						_semanticUiReact.Grid,
						{ stackable: true, columns: 2 },
						_react2.default.createElement(
							_semanticUiReact.Grid.Row,
							null,
							_react2.default.createElement(
								_semanticUiReact.Grid.Column,
								{ width: 8 },
								this.renderFormCalculs()
							),
							_react2.default.createElement(
								_semanticUiReact.Grid.Column,
								{ width: 8 },
								this.renderCalculComparatives()
							)
						)
					),
					_react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
				);
			}
		}
	}, {
		key: "renderErrorMessage",
		value: function renderErrorMessage(message) {

			return _react2.default.createElement(
				_semanticUiReact.Message,
				{ icon: true, negative: true },
				_react2.default.createElement(_semanticUiReact.Icon, { name: "warning sign" }),
				_react2.default.createElement(
					"p",
					null,
					message
				)
			);
		}
	}, {
		key: "isAnyCalcSelected",
		value: function isAnyCalcSelected() {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {

				for (var _iterator = CONSTANTS.OPT_CALCULS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var calc = _step.value;

					if (this.props.calcdatafieldsCalculs[calc.value]) {
						return true;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return false;
		}
	}, {
		key: "isValid",
		value: function isValid() {

			var missingCamps = this.props.calcdatafields.length < 1;
			var missingCalculs = !this.isAnyCalcSelected();

			if (!missingCalculs && !missingCamps) {
				return true;
			}

			this.setState({ missingCalculs: missingCalculs, missingSelectedFields: missingCamps });
			return false;
		}
	}, {
		key: "getJsonconfigState",
		value: function getJsonconfigState() {

			return null;
		}
	}, {
		key: "render",
		value: function render() {

			return _react2.default.createElement(
				_semanticUiReact.Container,
				{ fluid: true, textAlign: "justified" },
				_react2.default.createElement(
					_semanticUiReact.Header,
					{ as: "h4" },
					CONSTANTS.STEPS[this.props.myStep].description
				),
				this.state.missingSelectedFields && this.renderErrorMessage(CONSTANTS.STRING_ERROR_CAMPS),
				this.state.missingCalculs && this.renderErrorMessage(CONSTANTS.STRING_ERROR_CALCULS),
				!this.props.isCSVFile && !this.isUltimValor && !(this.props.timerange.singledays && this.props.timerange.dynamic) && !this.isToday() && this.renderSelectGranularitat(),
				this.renderFields(),
				this.id()
			);
		}
	}]);

	return PanelTractarDades;
}(_react2.default.Component);

exports.default = PanelTractarDades;


PanelTractarDades.propTypes = {
	calcdatafields: _propTypes2.default.array,
	calcdatafieldsOptions: _propTypes2.default.object,
	calcdatafieldsCalculs: _propTypes2.default.object,
	iscat: _propTypes2.default.bool,
	selectedfields: _propTypes2.default.array,
	timerange: _propTypes2.default.object,
	isCSVFile: _propTypes2.default.bool,
	myStep: _propTypes2.default.number,
	updateJsonConfig: _propTypes2.default.func
};
